import React from 'react';
import { Box, Divider, List } from '@mui/material';
import { useAppSelector } from '../../../../store/hooks';
import CampaignAddressListItem from './CampaignAddressListItem/CampaignAddressListItem';
import { selectCampaignAddressesIds } from '../../../../store/reducers/awareness_campaigns/addresses';

const CampaignAddressesList: React.FC = () => {
    const addresses = useAppSelector(state => selectCampaignAddressesIds(state));

    return (
        <List>
            {addresses.map((addressID) => (
                <Box key={addressID}>
                    <CampaignAddressListItem key={addressID} ID={addressID} />
                    <Divider />
                </Box>
            ))}
        </List>
    );
};

export default CampaignAddressesList;
